<template>
  <div class="header">
    <div class="logo" :class="{'is-active':isActive}">
      <img src="@/assets/logo3.png" alt="" height="30px">
      日管系統
      <!--      <img src="@/assets/lh-crm.png" alt="" height="30px">-->
    </div>
    <div class="navbar">
      <div class="btn" :class="{'is-active':isActive}" @click="handleMenu">
        <span :class="menuBtn"></span>

      </div>
      <div v-if="devMode=='Y'" style="background-color: red; padding: 20px;"><span style="color:white; text-align: center; font-weight: bold;">此為測試區</span></div>
      <div>

        <span class="mr-20 el-dropdown-link">
          <el-badge :value="badgeInfo" class="item">
            <el-button size="small" icon="el-icon-s-comment" circle @click="openMessage"></el-button>
          </el-badge>
        </span>
        <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <img :src="showAvatar(userInfo.avatar)" class="profile">
          {{ userInfo.username }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link to="/user/profile">
                <i class="el-icon-s-custom"></i> 個人資訊
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout"><i class="el-icon-right"></i> 登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>


    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'Header',
  data() {
    return {
      docUrl : process.env.VUE_APP_LH_DOC_URL,
      menuBtn: 'el-icon-newfont-caidan',
      devMode: process.env.VUE_APP_DEV_MODE
    }
  },
  computed: {
    ...mapState('login', ['userInfo', 'badgeInfo']),
    isActive() {
      return !this.$store.getters.sidebar.opened
    }
  },
  methods: {
    ...mapMutations({
      bindLogout: 'BIND_LOGOUT',
    }),
    handleMenu() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$confirm('是否登出?', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.get("/user/logout").then(res => {
          this.$store.state.login.token = null
          this.$store.state.login.userInfo = {}
          this.bindLogout()
          this.$router.push({
            path: '/login'
          })
        })

      }).catch((e) => {
        console.log('push error:', e.message)
      })
    },
    showAvatar(avatar) {
      return this.displayAvatar(avatar)
    },
    openMessage() {
      this.$router.push('/message/notification')
    }

  },
  mounted() {
    console.log("docUrl:", this.docUrl)
  }
}
</script>

<style scoped>
.profile {
  width: 36px;
  height: 36px;
  border-radius: 999px;
}
</style>
<style scoped lang="stylus">
.header
  width 100%
  height 50px
  display flex
  background #ffffff

  .logo
    width 200px
    height 50px
    background #000
    color #fff
    text-indent 15px
    font-size 18px
    line-height 50px
    font-weight 600
    transition .4s ease

    &.is-active
      width 64px

    img
      padding 0 5px 5px 0

  .navbar
    flex 1
    display flex
    align-items center
    justify-content space-between
    padding 0 10px
    color #000000

    .btn
      height 50px
      line-height 50px;
      cursor pointer
      transition .4s ease

      &.is-active
        transform: rotateY(180deg)

      span
        font-size 28px
        line-height 50px
        transition 0.5s
        color #FAB72B
        font-weight 400

    .el-dropdown-link
      color #000000
      font-weight bold
      cursor pointer

@media all and (max-width: 768px) {
  .header .logo.is-active {
    width: 0;
    overflow: hidden;
  }
}
</style>
